import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import type {
    ListRepositoriesQueryModel,
    ListRepositoriesResponse,
} from '@xver/apis/v1/kufer/github/model';

export const GITHUB_REPOSITORIES_QUERY_KEY = ['apis.v1.kufer.github.repositories'];

interface UseGitHubRepositoriesQueryOptions {
    enabled?: boolean;
}

export function useGitHubRepositoriesQuery(
    params: ListRepositoriesQueryModel = { per_page: 100 },
    options: UseGitHubRepositoriesQueryOptions = {}
) {
    const { enabled = true } = options;

    return useQuery<ListRepositoriesResponse>({
        queryKey: [...GITHUB_REPOSITORIES_QUERY_KEY, params],
        queryFn: () => Endpoints.v1.Kufer.GitHub.listRepositories(params),
        enabled,
        retry: false,
        staleTime: 30_000,
    });
}
